import { useEffect, useRef } from 'react';

import segment from '@flipster/utils/segment';
import { MainEvent } from '@flipster/utils/segment/events/main';
import { useMounted } from '@flipster/react/misc/lifecycle/mount';

export function useMainPageIntersectionSegment<T extends HTMLElement | null>(
  ref: React.RefObject<T>,
  section_title: string,
  options: IntersectionObserverInit = {
    threshold: 1,
  },
) {
  const hasSentSegment = useRef(false);

  const isMounted = useMounted();

  const dom = ref.current;

  useEffect(() => {
    if (!isMounted) return;

    if (dom && typeof IntersectionObserver === 'function') {
      const observer = new IntersectionObserver(
        (entries) => {
          for (const entry of entries) {
            if (entry.isIntersecting && !hasSentSegment.current) {
              segment.track(MainEvent.MainPageScroll, {
                section_title,
              });
              hasSentSegment.current = true;
              observer.disconnect();
            }
          }
        },
        {
          root: options.root,
          rootMargin: options.rootMargin,
          threshold: options.threshold,
        },
      );
      observer.observe(dom);

      return () => {
        observer.disconnect();
      };
    }
  }, [isMounted, dom, options.threshold, options.root, options.rootMargin, section_title]);
}
